import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Send = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="m11.5 16.14-.231.093m0 0-2.614 1.06a.5.5 0 0 1-.628-.7l1.82-3.384m0 0-6.43-2.058a.5.5 0 0 1-.014-.948L21 4l-6.599 16.915a.5.5 0 0 1-.918.031l-2.214-4.713m0 0L9.848 13.21m0 0L21 4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Send) as SvgIcon;
export { ForwardRef as ReactComponent };
